import 'babel-polyfill';
import Vue from 'vue';
import App from './App.vue';
import router from './router';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import 'element-ui/lib/theme-chalk/display.css';
Vue.use(ElementUI);
import API from './request';
import moment from 'moment';

import common from './utils/common'; //引用
Vue.use(common); //将全局函数当做插件来进行注册

Vue.filter('date', function (n) {
  if (n > 0) {
    return moment(n * 1000).format('YYYY-MM-DD HH:mm:ss'); // 转换时间格式
  } else {
    return '';
  }
});
Vue.filter('dateYmd', function (n) {
  if (n > 0) {
    return moment(n * 1000).format('YYYY-MM-DD'); // 转换时间格式
  } else {
    return '';
  }
});

Vue.config.productionTip = false;
Vue.prototype.$api = API;
Vue.prototype.$permMark = [];
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
});
